import { render, staticRenderFns } from "./wxAccount.vue?vue&type=template&id=b2a2df4c"
import script from "./wxAccount.vue?vue&type=script&lang=js"
export * from "./wxAccount.vue?vue&type=script&lang=js"
import style0 from "./wxAccount.vue?vue&type=style&index=0&id=b2a2df4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports